<template>
  <el-container class="content-wrap">
    <div class="headerCom"> 
      <publicBreadCrumb :breadList="breadList"/> 
      <publicFoldSearch :searchList='searchList' v-on:getSearchObj='getSearchObj' />
    </div> 
    <!-- 表格 -->
    <el-main style="padding: 0;">
      <BaseTable v-if="$store.state.userPlatForm === 'organization'"
        style="background-color: #fff;padding: 20px;margin: 0 17px;" :data="tableData" :column="tabListL1Config"
        pagination :auto-scroll="true" :total="totalPage" :page.sync="searchParams.current"
        @selection-change="selectionChange" :limit.sync="searchParams.size" @pagination="getList">
      </BaseTable>
      <BaseTable v-if="$store.state.userPlatForm === 'platForm'"
        style="background-color: #fff;padding: 20px;margin: 0 17px;" :data="tableData" :column="tabListL2Config"
        pagination :auto-scroll="true" :total="totalPage" :page.sync="searchParams.current"
        @selection-change="selectionChange" :limit.sync="searchParams.size" @pagination="getList">
      </BaseTable>
    </el-main>
    <!-- 弹窗信息 -->
    <el-dialog title="订单详情" :visible.sync="drawerFlag" width="50%" top="5vh" center :close-on-click-modal="false">
      <!-- 全病程订单 -->
      <div class="popup-view" v-if="orderType == 1">
        <el-form label-position="left" label-width="100px">
          <el-form-item label="订单编号" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInfoVO.orderNo }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>病人</div>
              <span>{{ orderDetails.orderInfoVO.patientName }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="医生团队" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInfoVO.doctorTeamName }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>领衔医生</div>
              <span>{{ orderDetails.orderInfoVO.doctorName }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="归属医院" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInfoVO.hospitalName }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>服务名称</div>
              <span>{{ orderDetails.wholeCourseVO.patientSchemeName }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="服务周期" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.wholeCourseVO.period }}{{ orderDetails.wholeCourseVO.periodType | periodType }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="服务单价" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInfoVO.amountOriginal }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>应付金额</div>
              <span>{{ orderDetails.orderInfoVO.amountPayable }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="优惠金额" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInfoVO.amountPayable - orderDetails.orderInfoVO.amountOriginal }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>实付金额</div>
              <span>{{ orderDetails.orderPayVO.payAmount ? orderDetails.orderPayVO.payAmount : '-' }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="创建时间" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInfoVO.createTime }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="支付方式" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderPayVO.paymentMethid | filterPay}}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>支付时间</div>
              <span>{{ orderDetails.orderPayVO.payTime }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="商户订单号" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderPayVO.transactionNo?orderDetails.orderPayVO.transactionNo:'--' }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>订单状态</div>
              <span>{{ orderDetails.orderPayVO.paymentState | payStatus }}</span>
            </el-col>
          </el-form-item>
        </el-form>
        <!-- 服务记录 -->
        <el-form label-position="left" label-width="100px">
          <el-form-item label="服务确认" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.wholeCourseVO.auditorDoctorName }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>确认时间</div>
              <span>{{ orderDetails.wholeCourseVO.auditorDoctorTime }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="服务时间" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.wholeCourseVO.startTime }} 至 {{ orderDetails.wholeCourseVO.stopTime }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>结束时间</div>
              <span>{{ orderDetails.wholeCourseVO.stopTime }}</span>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <!-- 问诊订单 -->
      <div class="popup-view" v-if="orderType == 3">
        <el-form label-position="left" label-width="100px">
          <el-form-item label="订单编号：" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInfoVO.orderNo }}</span>
            </el-col>
            <el-col :span="13" class="flex-view">
              <span class="labelRight">订单状态：</span>
              <span>{{ orderDetails.orderPayVO.paymentState | payStatus }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="病人：" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInfoVO.patientName }}</span>
            </el-col>
            <el-col :span="13" class="flex-view">
              <span class="labelRight">问诊状态：</span>
              <span>{{ orderDetails.orderInquiryDetailVO.inquiryStatusName }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="抵扣权益：" class="el-formno-bottom">
            <el-col :span="11" v-if="orderDetails.orderPayVO.paymentMethid=='4'">
              <span>{{ orderDetails.orderInquiryDetailVO.serviceName }}</span>
            </el-col>
            <el-col :span="11" v-else>
              <span>--</span>
            </el-col>
            <el-col :span="13" class="flex-view">
              <span class="labelRight">问诊类型：</span>
              <span>{{  orderDetails.orderInquiryDetailVO.returnVisitType==1?'图文问诊':'' }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="问诊团队：" class="el-formno-bottom"
            v-if="orderDetails.orderInquiryDetailVO.serviceProvider=='2'">
            <el-col :span="11">
              <span>{{ orderDetails.orderInfoVO.doctorTeamName }}</span>
            </el-col>
            <el-col :span="13" class="flex-view">
              <span class="labelRight">主诊医生：</span>
              <span>{{ orderDetails.orderInfoVO.doctorName }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="问诊医生：" class="el-formno-bottom"
            v-if="orderDetails.orderInquiryDetailVO.serviceProvider=='1'">
            <el-col :span="11">
              <span>{{ orderDetails.orderInfoVO.doctorName }}</span>
            </el-col>
            <el-col :span="13" class="flex-view">
              <span class="labelRight">职称：</span>
              <span>{{ orderDetails.orderInfoVO.jobTitle }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="服务类型:" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInquiryDetailVO.inquiryType == 3? '义诊': orderDetails.orderInquiryDetailVO.inquiryType == 2?'付费问诊':'权益问诊' }}</span>
            </el-col>
            <el-col :span="13" class="flex-view">
              <span class="labelRight">创建时间：</span>
              <span>{{  orderDetails.orderInquiryDetailVO.createTime }}</span>
            </el-col>

            <!-- <el-col :span="13" class="flex-view">
              <span class="labelRight">线下机构：</span>
              <span>{{ orderDetails.orderInfoVO.hospitalName }}</span>
            </el-col> -->
          </el-form-item>
          <el-form-item label="订单创建人：" class="el-formno-bottom">
            <el-col :span="11" class="flex-view">
              <span>==========</span>
            </el-col>
            <el-col :span="13" class="flex-view">
              <span class="labelRight">订单付款人：</span>
              <span>==========</span>
            </el-col>
          </el-form-item>
          <!-- <el-form-item label="创建时间：" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInquiryDetailVO.createTime }}</span>
            </el-col> -->
          <!-- <el-col :span="13" class="flex-view">
              <span class="labelRight">互医机构：</span>
              <span>{{ orderDetails.orderInfoVO.platformName  }}</span>
            </el-col> -->
          <!-- </el-form-item> -->
          <!-- <el-form-item v-if="$store.state.userPlatForm === 'organization'" label="互医机构" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.doctorVO.platformName }}</span>
            </el-col>
          </el-form-item>
          <el-form-item v-if="$store.state.userPlatForm === 'platForm'" label="线下机构" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInfoVO.hospitalName }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>互医机构</div>
              <span>{{ orderDetails.orderInfoVO.platformName }}</span>
            </el-col>
          </el-form-item> -->
          <!-- <el-form-item label="归属平台" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.doctorVO.platformName }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>服务名称</div>
              <span>{{ orderDetails.orderInquiryDetailVO.serviceName }}</span>
            </el-col>
          </el-form-item> -->
          <!-- <el-form-item label="服务名称" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInquiryDetailVO.serviceName }}</span>
            </el-col>
          </el-form-item> -->
          <el-form-item label="服务单价：" class="el-formno-bottom">
            <el-col :span="11" class="flex-view">
              <span>{{ orderDetails.orderInfoVO.amountOriginal }}</span>
            </el-col>
            <el-col :span="13" class="flex-view">
              <span class="labelRight">应付金额：</span>
              <span>{{ orderDetails.orderInfoVO.amountPayable }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="优惠金额：" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInfoVO.amountPayable - orderDetails.orderInfoVO.amountOriginal == 0 ? '-' : orderDetails.orderInfoVO.amountPayable - orderDetails.orderInfoVO.amountOriginal }}</span>
            </el-col>
            <el-col :span="13" class="flex-view">
              <span class="labelRight">实付金额：</span>
              <span>{{ orderDetails.orderPayVO.payAmount }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="支付方式：" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderPayVO.paymentMethid |filterPay }}</span>
            </el-col>
            <el-col :span="13" class="flex-view">
              <span class="labelRight">支付时间：</span>
              <span>{{ orderDetails.orderPayVO.payTime }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="商户订单号：" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderPayVO.transactionNo?orderDetails.orderPayVO.transactionNo:'--' }}</span>
            </el-col>
            <el-col :span="13" class="flex-view">
              <span class="labelRight">服务时长：</span>
              <span>{{ orderDetails.orderInquiryDetailVO.serviceTime }}</span>
            </el-col>
          </el-form-item>
          <!-- <el-form-item label="创建时间" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInquiryDetailVO.createTime }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>订单状态</div>
              <span>{{ orderDetails.orderPayVO.paymentState | payStatus }}</span>
            </el-col>
          </el-form-item> -->
          <el-form-item label="服务开始时间：" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInquiryDetailVO.startTime}}</span>
            </el-col>
            <el-col :span="13" class="flex-view">
              <span class="labelRight">服务结束时间：</span>
              <span>{{ orderDetails.orderInquiryDetailVO.endTime }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="退款人：" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderPayVO.createUserName?orderDetails.orderPayVO.createUserName:'--' }}</span>
            </el-col>
            <el-col :span="13" class="flex-view">
              <span class="labelRight">退款时间：</span>
              <span>{{ orderDetails.orderPayVO.refundTime?orderDetails.orderPayVO.refundTime:'--' }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="退款金额：" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderPayVO.refundMoney?orderDetails.orderPayVO.refundMoney:"--" }}</span>
            </el-col>
            <el-col :span="13" class="flex-view">
              <span class="labelRight">退款说明：</span>
              <span>{{ orderDetails.orderPayVO.refundText?orderDetails.orderPayVO.refundText:'--' }}</span>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <!-- 药品订单 -->
      <div class="popup-view" v-if="orderType == 2">
        <el-form label-position="left" label-width="70px">
          <el-form-item label="订单编号" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInfoVO.orderNo }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>处方编号</div>
              <span>{{ orderDetails.elecPrescriptionVO.no }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="病人" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.elecPrescriptionVO.patientName }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>处方类型</div>
              <span>{{ orderDetails.elecPrescriptionVO.type | prescriptionVO }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="问诊医生" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.elecPrescriptionVO.prescriberName }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>职称</div>
              <span>{{ orderDetails.elecPrescriptionVO.prescriberTitleName }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="归属医院" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.elecPrescriptionVO.prescriberHospitalName }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>创建时间</div>
              <span>{{ orderDetails.elecPrescriptionVO.createTime }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="服务单价" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInfoVO.amountOriginal }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>快递运费</div>
              <span>{{ orderDetails.elecPrescriptionVO.shippingPrice }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="优惠金额" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderInfoVO.amountPayable - orderDetails.orderInfoVO.amountOriginal }}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>实付金额</div>
              <span>{{ orderDetails.orderInfoVO.payAmount ? orderDetails.orderInfoVO.payAmount : '-' }}</span>
            </el-col>
          </el-form-item>

          <el-form-item label="支付方式" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderPayVO.paymentMethid |filterPay}}</span>
            </el-col>
            <el-col :span="11" class="flex-view">
              <div>支付时间</div>
              <span>{{ orderDetails.orderPayVO.payTime }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="订单状态" class="el-formno-bottom">
            <el-col :span="11">
              <span>{{ orderDetails.orderPayVO.paymentState | payStatus }}</span>
            </el-col>
            <el-col :span="12" class="flex-view">
              <div>商户订单号</div>
              <span>{{ orderDetails.orderPayVO.transactionNo?orderDetails.orderPayVO.transactionNo:'--' }}</span>
            </el-col>
          </el-form-item>
        </el-form>
        <!-- 表格 -->
        <BaseTable :cell-style="{ padding: '0' }" :row-style="{ height: '20px' }" size="medium" border stripe
          :data="orderDetails.elecPrescriptionVO.itemList" :column="prescriptionConfigL"> </BaseTable>
        <!-- 处方内容 -->
        <el-form label-position="left" label-width="80px">
          <el-form-item label="处方查看"> </el-form-item>
        </el-form>
        <!-- <img :src="require('@/assets/images/logo.png')" alt="" class="img-view" @click="$imageViewer" /> -->
        <!-- 服务记录 -->
        <!-- <el-form label-position="left" label-width="80px">
                    <el-form-item label="服务记录" class="el-h1">
                    </el-form-item>
                </el-form>
                <BaseTable 
                    :cell-style="{padding: '0'}" 
                    :row-style="{height:'20px'}" 
                    size="medium" 
                    height="250"
                    border 
                    stripe 
                    :data="tableData" 
                    :column="serviceConfig"
                   >
                </BaseTable>  -->
        <!-- 退款记录 -->
        <!-- <el-form label-position="left" label-width="480px">
                    <el-form-item label="退款记录(服务开始后不支持退款)" class="el-h1">
                        <el-button>办理退款</el-button>
                    </el-form-item>
                </el-form> -->
        <!-- <el-form label-position="left" label-width="85px" >
                    <el-form-item label="退款人" class="el-formno-bottom"> 
                        <el-col :span="11">
                            <span>李贺（医生）</span>
                        </el-col>
                        <el-col :span="11" class="flex-view">
                            <div>退款时间</div>
                            <span>2019-12-12  12:4</span>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="退款原因" class="el-formno-bottom"> 
                        <el-col :span="11">
                            <span>2019-12-12  至  2020-2-11</span>
                        </el-col>
                    </el-form-item>
                </el-form> -->
        <!-- <el-form label-position="left" label-width="80px">
                    <el-form-item label="费用开支" class="el-h1">
                    </el-form-item>
                    <el-form-item label="平台分成" class="el-formno-bottom"> 
                        <el-col :span="11">
                            <span>订单结束后分成</span>
                        </el-col>
                        <el-col :span="11" class="flex-view">
                            <div>医生酬金</div>
                            <span>服务结束后获取结束时</span>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="三方货款" class="el-formno-bottom"> 
                       <el-col :span="11">
                            <span>订单结束后分成</span>
                        </el-col>
                        <el-col :span="11" class="flex-view">
                            <div>三方服务</div>
                            <span>订单结束后分成</span>
                        </el-col>
                    </el-form-item>
                </el-form> -->
      </div>
    </el-dialog>
    <!-- 退款弹窗 -->
    <el-dialog class="refundDialog" title="退款" Destroy-on-close :visible.sync="showRefund" :close-on-click-modal="false"
      width="30%" center>
      <el-form status-icon label-width="80px" ref="refundRef" :model="refund" :rules="refundRules">
        <el-form-item label="退款金额" prop="refundMoney">
          <el-input v-model="refund.refundMoney" placeholder="请输入退款金额"></el-input>
        </el-form-item>
        <el-form-item label="退款说明" prop="refundText">
          <el-input type="textarea" v-model="refund.refundText" placeholder="请输入退款说明"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button slot="reference" type="primary" @click="submitHandel">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
/**
 * L1全病程
 * L2问诊订单
 * L3药品订单
 *
 */
import interrogation from "./common/interrogation";
import axios from "axios";
import qs from "qs";
import { plateFormOn } from "@/api/acc.js";
import {
  getOrderList,
  getOrderDetails,
  getServiceByType,
  prescriptionRefund
} from "./api/orderPay";
import { hospital } from "@/api/doctorTeam";
export default {
  mixins: [interrogation],
  data() {
    var checkMoney = (rule, value, callback) => {
      if (!value || value == 0) {
        return callback(new Error("金额不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value * 100)) {
          callback(new Error("请输入正确的金额"));
        } else {
          if (value > this.scopeItme.payAmount) {
            callback(new Error("退款金额不可大于实付金额"));
          } else {
            callback();
          }
        }
      }, 1000);
    };
    return {
      breadList:[{name:'订单管理'},{name:'全病程问诊订单'}],
      searchList: [
         {
          label: "订单编号",
          value: 1,
          paramName: "orderNo",
          inputType: "input" 
        }, 
        {
          label: "患者姓名",
          value: 2,
          paramName: "patientName",
          inputType: "input",
          maxLength:5
        },
        {
          label: "医生/医生团队",
          value: 3,
          paramName: "doctorName",
          inputType: "input" 
        }, 
         {
          label: "线下机构",
          value: 4,
          paramName: "hospitalId",
          inputType: "hospital",
          optionData: []
        }, 
        {
          label: "互医机构",
          value: 5,
          paramName: "platformName",
          inputType: "input"
        },  
         {
          label: "创建时间",
          value: 6,
          paramName: "timeRange",
          inputType: "datetimerange",
          isTime:true,
          paramstartTime: "startTime",
          paramEndTime: "endTime"
        },
        {
          label: "订单状态",
          value: 7,
          paramName: "paymentState",
          inputType: "select",
          optionData:[]
        }, 
        {
          label: "服务类型",
          value: 8,
          paramName: "inquiryType",
          inputType: "select",
          optionData: [
            {
              label: '权益问诊',
              value: 1,
            },
            {
              label: '付费问诊',
              value: 2,
            },
            {
              label: '义诊',
              value: 3,
            },
          ]
        } 
      ],
      searchParams: { 
        current: 1,
        size: 10,
        commodityType:'3'
      },
      scopeItme: "",
      inputValue: "",
      statusList: [],
      serviceTypeList: [],
      showRefund: false, //退款弹窗开关
      refund: {
        refundMoney: "", //退款金额
        refundText: "" //退款说明
      },
      refundRules: {
        refundMoney: [
          {
            validator: checkMoney,
            trigger: "blur",
            required: true
          }
        ],
        refundText: [
          {
            required: true,
            message: "请输入退款原因",
            trigger: "blur"
          }
        ]
      },
      activeName: "", //标签页选中
      totalPage: 0, 
      tableData: [],
      drawerFlag: false, 
      orderType: "", //1, "方案/全病程 2, "药品" 3, "问诊"
      orderDetails: {
        orderDrugDetailVO: {},
        doctorVO: {},
        orderInfoVO: {},
        orderInquiryDetailVO: {},
        orderPayVO: {},
        wholeCourseVO: {},
        elecPrescriptionVO: {}
      }, //订单详情
      popupActiveName: "first"
    };
  },
  methods: {
    getSearchObj(obj) {  
      //清空之前合并过的条件
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams }; 
      if(this.searchParams.hospitalName){
        delete this.searchParams.hospitalName
      } 
       if (this.$store.state.userPlatForm === "organization") { 
        this.searchParams.hospitalId = this.$store.state.hospitalId; 
      } 
      this.init();
    }, 
    /**
     * @description: 根据类型获取问诊服务
     * @param {serviceType：1}
     * @return {*}
     */
    getServiceByTypeHandel() {
      getServiceByType({
        serviceType: 1
      }).then(res => {
        if (res.code == 0) {
          this.serviceTypeList = res.data;
        }
      });
    }, 
    /***
     * 首页操作
     */
    hometHandel(scope, type) {
      this.orderType = scope.row.commodityType;
      if (type == "details") {
        getOrderDetails(scope.row.id).then(res => {
          if (res.code == 0) {
            this.orderDetails = res.data;
            this.drawerFlag = true;
          }
        });
      } else if (type == "refund") {
        this.$confirm("此操作将金额原路返回, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          customClass: "message-confirm-style"
        }).then(() => {
          const param = { id: scope.row.id };
          axios
            .post("admin/order-pay/refund", qs.stringify(param), {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            })
            .then(res => {});
        });
      }
    }, 
    /**
     * 分页事件
     */
    selectionChange() {},

    getList(e) {
      this.init();
    },
    /**
     * 获取首页数据
     */
    init() { 
      getOrderList(this.searchParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.records;
          this.totalPage = res.data.total;
        }
      }); 
    },
    //退款
    hometRefundHandel(scope) {
      this.showRefund = true;
      this.scopeItme = scope;
      this.refund.refundText = scope.refundText;
      return;
    },
    submitHandel() {
      this.$refs["refundRef"].validate(valid => {
        if (valid) {
          prescriptionRefund({
            ...this.refund,
            orderId: this.scopeItme.id,
            orderDetailId: this.scopeItme.detailId
          }).then(res => {
            if (res.code == 0) {
              this.$message.success(res.message);
              this.scopeItme = "";
              this.refund = this.$options.data().refund;
              this.showRefund = false;
              this.init();
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    }
  },
  mounted() {
    this.searchList[6].optionData = this.$defaultData.orderPayStatus
      if (this.$store.state.userPlatForm === "organization") {
      this.searchParams.hospitalId = this.$store.state.hospitalId;
      this.searchList.splice(2,2)
    }  
    this.init(); 
    this.getServiceByTypeHandel();
  },
  filters: {
    payStatus(key) {
      switch (key * 1) {
        case 1:
          return "待支付";
        case 2:
          return "已支付";
        case 3:
          return "已取消";
        case 4:
          return "已退款";
        case 7:
          return "已完成";
        case 8:
          return "待退款";
        default:
          return "未知";
      }
    },
    prescriptionVO(key) {
      switch (key * 1) {
        case 1:
          return "西药处方";
        case 2:
          return "中药处方";
        case 3:
          return "营养处方";
        case 4:
          return "运动处方";
        case 5:
          return "治疗处方";
        default:
          return "未知";
      }
    },
    periodType(key) {
      switch (key * 1) {
        case 1:
          return "天";
        case 2:
          return "月";
        case 3:
          return "周";
        case 4:
          return "季";
        case 5:
          return "年";
        default:
          return "未开始";
      }
    },
    filterServiceCode(key) {
      switch (key * 1) {
        case 1:
          return "在线问诊";
        case 2:
          return "在线续方";
        case 3:
          return "在线随访";
        case 4:
          return "在线复诊";
        default:
          return "未知";
      }
    }
  }
};
</script> 
<style>
.el-form-item__label {
  font-size: 12px !important;
}
</style>
<style lang="less" scoped>
@import "./order.less"; 
</style>
